import axios from 'lib/axios'
import { UPDATE_INVENTORY } from './constants'

export const fetchEditInventoryStatus = async (subscription_company_id: number, data: any) => {
  return axios.put(
    `/${UPDATE_INVENTORY}/${subscription_company_id}`,
    {
      items: [data],
    },
    {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    }
  )
}

// Nueva función para actualizar estado o fecha de expiración usando el nuevo endpoint PATCH
export const updateSubscriptionCompany = async (
  subscriptionCompanyId: number,
  data: { state?: boolean; expiration_date?: string }
) => {
  try {
    const response = await axios.patch(`/subscription_company/${subscriptionCompanyId}`, data, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    })

    return response.data
  } catch (error: any) {
    console.error('Error al actualizar suscripción de compañía:', error)

    // Log de detalles del error si están disponibles
    if (error.response?.data) {
      console.error('Detalle del error:', error.response.data)
    }

    throw error
  }
}
